export default __webpack_public_path__ + "static/media/mui.ca8121dd.svg";